export default __webpack_public_path__ + "static/timberline-electric-lab-large-689611d7fe7ee7241c801f7603d79d06.jpg";